import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHealthNotes = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		strokeLinecap: "round",
		strokeWidth: 1.5,
		stroke: "currentColor",
		fill: "none",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M7,5h-2c-0.552,0 -1,0.448 -1,1v15c0,0.552 0.448,1 1,1h14c0.552,0 1,-0.448 1,-1v-15c0,-0.552 -0.448,-1 -1,-1h-2" }),
			/* @__PURE__ */ _jsx("path", { d: "M8,16h8" }),
			/* @__PURE__ */ _jsx("path", { d: "M10,19h4" }),
			/* @__PURE__ */ _jsx("path", { d: "M9,4l0.447,-0.894c0.339,-0.678 1.032,-1.106 1.789,-1.106h1.528c0.758,0 1.45,0.428 1.789,1.106l0.447,0.894h1c0.552,0 1,0.448 1,1v1c0,0.552 -0.448,1 -1,1h-8c-0.552,0 -1,-0.448 -1,-1v-1c0,-0.552 0.448,-1 1,-1h1Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M10.5,11.5h3" }),
			/* @__PURE__ */ _jsx("path", { d: "M12,10v3" })
		]
	}), /* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M0,0h24v24h-24Z"
	})]
});
export default SvgHealthNotes;
